<div class="search-container">
    <form [formGroup]="searchForm">
        <app-basic-input
            [icons]="'i-search'"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.USERS.PLACEHOLDERS.SEARCH-FIELD' | translate,
                inputId: 'search',
                type: basicInputTypeEnum.TEXT
            }"
            formControlName="searchValue"
        >
        </app-basic-input>
        <button *ngIf="searchValue.value"
                class="reset-filters icon i-close"
                [title]="'SHARED.FILTERS.REINIT_SEARCH' | translate"
                (click)="resetSearch()"
        >
        </button>
    </form>
</div>
